<template>
  <div class="appointmentSacrificeSweep wh100">
    <navBar title="预约祭扫" :leftArrowFlag="true"></navBar>
    <div class="content">
      <h3>温馨提示</h3>
      <p>
        清明节期间，出行祭扫人员和车辆十分集中，请科学合理安排祭扫时间，错时错峰祭扫，祭扫时听从现场工作人员的安排引导，自觉维护祭扫场所公共秩序。提倡以鲜花祭扫、植树绿化、踏青遥祭、丝带寄哀思、吟诵祭文、网上祭扫等文明低碳祭扫方式，怀念逝者、寄托哀思。严禁在墓区焚香烧纸，燃放烟花爆竹、严防火灾发生。
      </p>
      <div class="large_btn" @click="goNext"><span>我知道了</span></div>
    </div>
  </div>
</template>

<script>
import navBar from "@/components/navBar";
export default {
  data() {
    return {
      peopleNum: 0,
    };
  },
  components: {
    navBar,
  },
  created() {
    this.peopleNum = JSON.parse(
      localStorage.getItem("adminconfig")
    ).maxAttendNum;
  },
  methods: {
    goNext() {
      this.$router.push("/appointment/appointmentTime");
    },
  },
};
</script>

<style lang="scss" scoped>
.appointmentSacrificeSweep {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  .content {
    flex: 1;
    padding: 0.15rem;
    h3 {
      font-size: 16px;
      line-height: 0.27rem;
      text-align: center;
      margin-bottom: 0.15rem;
    }
    p {
      font-size: 14px;
      line-height: 0.3rem;
    }
    .large_btn {
      margin-top: 3rem;
    }
  }
}
</style>
